var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "jade-icon-shape", class: _vm.computedClass },
    [
      _c("jade-icon", {
        attrs: { use: _vm.use, size: _vm.computedSize, color: "current-color" },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }